import {BaseCriteriaModel} from '../base-criteria.model';
import {Optional} from 'typescript-optional';

export class PGWContractQueryCriteriaClass extends BaseCriteriaModel {
  payment_channel_guid?: Optional<string> = Optional.empty();
  pgwc_guid?: Optional<string> = Optional.empty();
  comp_guid?: Optional<string> = Optional.empty();
  obj_type?: Optional<string> = Optional.empty();
  hdr_guids?: Optional<string> = Optional.empty(); /** @param hdr_guids is comma separated E.g: 4BC80017-22CC-4A29-9511-E22C4EB97AD5,4BC80017-22CC-4A29-9511-E22C4EB97AD5*/

  //For events
  event_code?: Optional<string> = Optional.empty();
  action?: Optional<string> = Optional.empty();

}

export class PGWContractCriteriaModelQuery {
  query = '';

  constructor(contractCriteriaModel: PGWContractQueryCriteriaClass) {
    console.log('pCCriteriaModel', contractCriteriaModel);

    if (!contractCriteriaModel) {
      return;
    }

    this.query += contractCriteriaModel.payment_channel_guid.filter(x => x !== '').map(x => '&payment_channel_guid=' + x).orElse('');
    this.query += contractCriteriaModel.pgwc_guid.filter(x => x !== '').map(x => '&pgwc_guid=' + x).orElse('');
    this.query += contractCriteriaModel.comp_guid.filter(x => x !== '').map(x => '&comp_guid=' + x).orElse('');
    this.query += contractCriteriaModel.obj_type.filter(x => x !== '').map(x => '&obj_type=' + x).orElse('');
    this.query += contractCriteriaModel.hdr_guids.filter(x => x !== '').map(x => '&hdr_guids=' + x).orElse('');

    this.query += contractCriteriaModel.event_code.filter(x => x !== '').map(x => '&event_code=' + x).orElse('');
    this.query += contractCriteriaModel.action.filter(x => x !== '').map(x => '&action=' + x).orElse('');


    this.query += '&status=' + contractCriteriaModel.status;
    this.query += '&orderBy=' + contractCriteriaModel.orderBy;
    this.query += '&order=' + contractCriteriaModel.order;
    this.query += '&offset=' + contractCriteriaModel.offset + '&limit=' + contractCriteriaModel.limit;
  }

}
